import React, { useMemo } from 'react';
import moment from 'moment';
import { get } from 'lodash';

import OrderContent from './OrderContent';
import withAccountLayout from '../../components/account/withAccountLayout';
import AccordionTitle from '../../components/account/AccordionTitle';
import { apiClient } from '../../../helpers/apiHelperV2';
import Currency from '../../../helpers/currency';
import Button from '../../components/form-elements/Button';
import { ExternalLink } from '../../components/form-elements/Link';

moment.locale('de');

function OrderHistory({ orders = [], selectedLocation }) {
    const closedOrders = useMemo(() => {
        return orders
            .filter(
                order =>
                    !get(order, 'cart.products', []).some(
                        p =>
                            p.orderStatus !== 'completed' &&
                            p.orderStatus !== 'cancelled' &&
                            p.orderStatus !== 'completedProductExchange' &&
                            p.orderStatus !== 'reversed' &&
                            p.orderStatus !== 'refunded'
                    )
            )
            .filter(order => (selectedLocation ? order.markenStandort._id === selectedLocation : true));
    }, [orders, selectedLocation]);

    const handleInvoiceMail = ({ orderId, invoiceId }) => async () => {
        const { data: message } = await apiClient.post('/api/v1/account/invoice', { orderId, invoiceId }, { authenticated: true });
        window.UIkit.notification(message, { status: 'success', pos: 'top-right' });
    };

    return (
        <div className="uk-container">
            <ul data-uk-accordion="multiple: true">
                {closedOrders.map(order => {
                    return Object.values(order.productsByLieferweg).map(lieferwege => {
                        if (!lieferwege.length) return null;
                        return (
                            <li key={order._id} className="uk-open">
                                <AccordionTitle>
                                    <div>Bestelldatum: {moment(order.created).format('LLL')}</div>
                                    <div>Bestell-NR: {order.id}</div>
                                </AccordionTitle>
                                <div className="uk-accordion-content" data-uk-margin="">
                                    <h5>
                                        {lieferwege[0]?.selectedLieferweg?.type === 'montage'
                                            ? 'Abholen in der Filiale inklusive Montage'
                                            : lieferwege[0]?.selectedLieferweg?.bezeichnung}
                                    </h5>
                                    <div className="uk-grid uk-grid-small uk-grid-divider" data-uk-grid="">
                                        {lieferwege?.map((product, index) => (
                                            <div key={index} className="uk-width-1-1">
                                                <OrderContent orderId={order._id} product={product} markenStandort={order.markenStandort} />
                                            </div>
                                        ))}
                                    </div>
                                    {order?.invoices?.length > 0 && (
                                        <div>
                                            <h5>Rechnungen zu dieser Bestellung:</h5>
                                            <table className="uk-table uk-table-small">
                                                <thead>
                                                    <tr>
                                                        <th className="uk-padding-remove-vertical uk-text-default">Dateiname</th>
                                                        <th className="uk-padding-remove-vertical uk-text-right uk-text-default">
                                                            Rechnungsbetrag
                                                        </th>
                                                        <th className="uk-padding-remove-vertical uk-text-right uk-text-default">
                                                            Bestellnummer
                                                        </th>
                                                        <th className="uk-padding-remove-vertical uk-text-right uk-text-default">
                                                            Rechnungsdatum
                                                        </th>
                                                        <th className="uk-padding-remove-vertical uk-text-right uk-text-default">
                                                            Rechnung als Mail
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {order.invoices.map(invoice => (
                                                        <tr key={invoice._id}>
                                                            <td>
                                                                <ExternalLink
                                                                    to={`https://techno-images.s3.eu-central-1.amazonaws.com/${order.markenStandort._id}/${invoice.filename}`}
                                                                >
                                                                    {invoice.filename}
                                                                </ExternalLink>
                                                            </td>
                                                            <td className="uk-text-right">
                                                                <Currency quantity={invoice.betrag} />
                                                            </td>
                                                            <td className="uk-text-right">{invoice.rechnungsnr}</td>
                                                            <td className="uk-text-right">{moment(invoice.date).format('LLL')}</td>
                                                            <td className="uk-text-right">
                                                                <Button
                                                                    onClick={handleInvoiceMail({
                                                                        orderId: order._id,
                                                                        invoiceId: invoice._id,
                                                                    })}
                                                                >
                                                                    Email versenden
                                                                </Button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </div>
                            </li>
                        );
                    });
                })}
            </ul>
            {!closedOrders.length && (
                <div className="uk-placeholder uk-flex uk-flex-center">Es sind keine abgeschlossenen Bestellungen vorhanden.</div>
            )}
        </div>
    );
}
export default withAccountLayout(OrderHistory, { title: 'Meine abgeschlossenen Bestellungen' });
